import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './utilisateurs.routes';

export class UtilisateursController {

  constructor($scope, $http, Auth) {
    var vm = this;
    vm.orderBy = "client";
    vm.reverseSort = false;

    $http.get('/api/users').then(response => {
      vm.users = response.data;
    });

    vm.createUser = function(form){ 
      vm.action = 'save';
      vm.data = {};
      vm.data.autorisations = {
        collecte : {active : true},
        greenBackground : {active : true},
        filter : {active : true},
        partage : {active : true, maxCount : 3},
        impression : {active : true, maxCount : 5},
        modes : {
          classique : {active :true},
          multipose : {active :true},
          gif : {active :true},
          boomerang : {active :true}
        }
      }
      $("#addUser").modal('show');
    }

    vm.editUser = function(user) {
      vm.action = 'edit';
      vm.data = angular.copy(user);
      $('#addUser').modal('show');
    }

    vm.addUser = function(form){ 
      if(form.$valid) {
        vm.errors = undefined;
        $scope.clicked = true;
        vm.data.autorisations.maxApplicationsCount = 'infinite';
        if(vm.action == 'save') {
          Auth.createUser(vm.data).then(() => {
            $http.get('/api/users').then(response => {
              vm.users = response.data;
              $('#addUser').modal('hide');
              $scope.clicked = false;
              vm.data = {};
            })
          }).catch(err => {
            console.log(err);
            vm.errors = {errorTitle : 'Erreur', errorMessage : err.data.message};
            $scope.clicked = false;
          });
        }
        if(vm.action == 'edit'){
          $http.patch(`/api/users/${vm.data._id}`, vm.data).then(response => {
            $http.get('/api/users').then(response => {
                vm.users = response.data;
                $('#addUser').modal('hide');
                $scope.clicked = false;
                vm.data = {};
            })
          }).catch(err => {
            console.log(err);
            vm.errors = {errorTitle : 'Erreur', errorMessage : err.data.message};
            $scope.clicked = false;
          })
        }
      }
    }

    vm.deleteUser = function(user) {
      vm.userToDelete = user;
      $('#deleteUser').modal('show');
    }

    vm.validateDelete = function(user) {
      $scope.clicked = true;
      $http.delete(`/api/users/${vm.userToDelete._id}`).then(function(){
        $http.get('/api/users').then(response => {
          vm.userToDelete = {};
          vm.users = response.data;
            $('#deleteUser').modal('hide');
            $scope.clicked = false;
          }).catch(function(){
            $('#deleteUser').modal('hide');
            $scope.clicked = false;
          });
      });
    }
  }
}

export default angular.module('bfastCaptureManagerApp.utilisateurs', [uiRouter])
  .config(routing)
  .component('utilisateurs', {
    template: require('./utilisateurs.html'),
    controller: UtilisateursController,
    controllerAs: 'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/utilisateurs/utilisateurs.component.js